/* @flow */

import * as React from 'react';
import Instructions from 'app/components/commons/Instructions';
import Divider from 'app/components/commons/Divider';
import LocalStorageWrapper from 'app/components/util/LocalStorageWrapper';

type Props = {
  children: any,
  storageKey: string,
  title?: string,
  hasDivider?: boolean
};

const defaultProps = {
  title: undefined,
  hasDivider: false
};

function CloseableInstructions({ children, storageKey, title, hasDivider }: Props) {
  return (
    <LocalStorageWrapper storageKey={storageKey}>
      {({ onChange, value }) =>
        !value && (
          <React.Fragment>
            <Instructions onClose={() => onChange('true')} title={title}>
              {children}
            </Instructions>
            {hasDivider && <Divider blank />}
          </React.Fragment>
        )
      }
    </LocalStorageWrapper>
  );
}

CloseableInstructions.defaultProps = defaultProps;

export default CloseableInstructions;
